var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLayerGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.605957 7.22754L11.98 12.3872C12.312 12.5381 12.6875 12.5381 13.0195 12.3872L24.3936 7.22754C25.2017 6.86084 25.2017 5.63965 24.3936 5.27295L13.02 0.112791C12.8569 0.0382262 12.6796 -0.000366211 12.5002 -0.000366211C12.3209 -0.000366211 12.1436 0.0382262 11.9805 0.112791L0.605957 5.27246C-0.202148 5.63916 -0.202148 6.86084 0.605957 7.22754ZM24.394 11.5381L21.5576 10.2524L13.665 13.8301C13.2959 13.9976 12.9038 14.0825 12.5 14.0825C12.0962 14.0825 11.7046 13.9976 11.335 13.8301L3.44287 10.2524L0.605957 11.5381C-0.202148 11.9043 -0.202148 13.125 0.605957 13.4912L11.98 18.647C12.312 18.7974 12.6875 18.7974 13.0195 18.647L24.394 13.4912C25.2021 13.125 25.2021 11.9043 24.394 11.5381ZM24.394 17.7783L21.5684 16.4976L13.665 20.0801C13.2959 20.2476 12.9038 20.3325 12.5 20.3325C12.0962 20.3325 11.7046 20.2476 11.335 20.0801L3.43213 16.4976L0.605957 17.7783C-0.202148 18.1445 -0.202148 19.3652 0.605957 19.7314L11.98 24.8872C12.312 25.0376 12.6875 25.0376 13.0195 24.8872L24.394 19.7314C25.2021 19.3652 25.2021 18.1445 24.394 17.7783Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLayerGroup);
export default __webpack_public_path__ + "static/media/icon-layer-group.ebf154112dee7e0842f4626e725b5587.svg";
export { ForwardRef as ReactComponent };